import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2","key":"svg-1"}]]

const IconCircleLetterD = createReactComponent('outline', 'circle-letter-d', 'CircleLetterD', __iconNode);

export default IconCircleLetterD;